import { SCHOOLY_API_V2_URL } from '../../../config';
import {
  buildCreateFacilitiesApiV2FacilitiesPostPath,
  buildGetFacilitiesBySchoolIdApiV2FacilitiesSchoolIdGetPath,
  buildUpdateFacilitiesApiV2FacilitiesSchoolIdPutPath,
} from '../../generated/schooly-api-v2';

export const createFacilitiesPath = () =>
  `${SCHOOLY_API_V2_URL}${buildCreateFacilitiesApiV2FacilitiesPostPath()}`;

export const getFacilitiesPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildGetFacilitiesBySchoolIdApiV2FacilitiesSchoolIdGetPath(params)}`;

export const updateFacilitiesPath = (params: { school_id: string }) =>
  `${SCHOOLY_API_V2_URL}${buildUpdateFacilitiesApiV2FacilitiesSchoolIdPutPath(params)}`;
